import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { uniqBy } from 'lodash'
import React, { memo } from 'react'
import Fade from 'react-reveal/Fade'

import { Props as StripeProps, Stripe } from './Stripe'

export interface Props {
  stripes: StripeProps[]
  variant?: Variant
}

export const ZigZagVisual = memo(function ZigZagVisual({
  stripes,
  variant = 'default',
}: Props) {
  if (stripes.length < 1) {
    return null
  }

  return (
    <Container variant={variant}>
      {uniqBy(stripes, 'title').map((item, index) => (
        <Fade key={index}>
          <Stripe isOdd={index % 2 === 0} {...item} />
        </Fade>
      ))}
    </Container>
  )
})

const Container = styled.section<ContainerProps>`
  overflow: hidden;

  ${({ theme, variant }) => {
    switch (variant) {
      case 'light':
        return css`
          background: ${theme.colors.variants.primaryLight1};
          padding-top: 14.375rem;

          @media (max-width: 1199px) {
            padding-top: 7.5rem;
          }
        `
      case 'dark':
        return css`
          background: ${theme.colors.variants.neutralDark1};
          padding-top: 14.375rem;

          @media (max-width: 1199px) {
            padding-top: 7.5rem;
          }
        `
    }
  }}
`

interface ContainerProps {
  variant: Variant
}

export type Variant = 'default' | 'light' | 'dark'
